// extracted by mini-css-extract-plugin
module.exports = {"socials":"_3CGYO","small":"kXyqi","big":"_3kqMt"};